import  { useQuery } from '@tanstack/react-query';
import { EstatesService } from '../../services/generatedApi';

const useOfficeEstates = (officeId: string, forSale: boolean | undefined, headStart: boolean | undefined, sold: boolean | undefined, otherOffices: string | undefined) => {
    return useQuery(
        ["officeEstates", officeId, forSale, headStart, sold],
        () => EstatesService.estatesGetEstatesForOffice(officeId, forSale, headStart, sold, otherOffices).then((response) => response),
        {
            enabled: forSale !== undefined || headStart !== undefined || sold !== undefined,
        }
    );
}

export default useOfficeEstates;